import { useEffect, useMemo, useState } from "react";
import "./RoleModuleManagement.scss";
import { APP_BASE_URL, USER_PERMISSION } from "../../../Common/EndPoints";
import { useImmer } from "use-immer";
import axios from "axios";
import toast from "react-hot-toast";

import { extractAllowedUserRoleList } from "../../../Utils/Utils";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Switch,
  Tooltip,
} from "@mui/material";
import DataTable from "../../../Components/DataGrid/DataGrid";

const initPermData = {
  isLoading: false,
  data: {},
  entity_list: [],
};
const initPemissionUpdateModel = {
  open: false,
  data: null,
};
const RoleUpdateModal = ({ open, data, handleCloseModal, refetchPermissions }) => {
  const isOpen = open && Boolean(data);
  const { role_name, role_entity_map } = data;
  const [entityStatus, setEntityStatus] = useImmer(() => {
    // const map = role_entity_map;
    const visible = {};
    const not_visible = {};
    Object.entries(role_entity_map ?? []).forEach(([key, val]) => {
      if (val) {
        visible[key] = val;
      } else {
        not_visible[key] = val;
      }
    });
    return { ...visible, ...not_visible };
  });
  const [updating, setUpdating] = useState(false);
  const handleSubmit = async () => {
    setUpdating(true);
    try {
      const accesses = [];
      Object.entries(entityStatus).forEach(([module, isvisible]) => {
        accesses.push({
          entity: module,
          read_all: isvisible,
        //   role_name: data.role_name,
          user_role_id: data.user_role_id,
        });
      });
      const url = `${APP_BASE_URL}${USER_PERMISSION}`;
      await axios.put(url, accesses);
      toast.success("Role Module Permissions Updated.")
      setUpdating(false);
      handleCloseModal();
      refetchPermissions();
    } catch (err) {
      toast.error(err.message || "Failed to update permissions.");
      setUpdating(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={handleCloseModal} maxWidth="md" fullWidth={true}>
      <DialogTitle className="flex items-center justify-between">
        Module Permissions for {role_name}
        <CloseIcon className="assets-info-popup-close-icon pointer" onClick={handleCloseModal} />
      </DialogTitle>
      <DialogContent>
        {/* <FormControl component="fieldset" variant="standard">
          <FormLabel component="legend">Pemissions</FormLabel> */}

        <FormGroup sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "0.3em" }}>
          {Object.entries(entityStatus ?? {}).map(([module, isVisible]) => {
            return (
              <FormControlLabel
              disabled={updating}
                sx={{ flex: "1", minWidth: "15em", border: "0.1px solid #e8e8e8", borderRadius: "6px" }}
                control={
                  <Switch
               
                    checked={isVisible}
                    onChange={(event) => {
                      setEntityStatus((prev) => {
                        prev[module] = event.target.checked;
                      });
                    }}
                    name={module}
                  />
                }
                labelPlacement="end"
                label={module}
              />
            );
          })}
        </FormGroup>
        {/* <FormHelperText>Be careful</FormHelperText> */}
        {/* </FormControl> */}
      </DialogContent>
      <DialogActions>
        <Button disabled={updating} variant="outline" onClick={handleCloseModal}>
          Close
        </Button>
        <Button disabled={updating} variant="contained" onClick={handleSubmit}>
          Update Module Permissions
        </Button>
      </DialogActions>
    </Dialog>
  );
};
const RoleModuleManagement = () => {
  const [permissionData, setPemissiondata] = useImmer(initPermData);

  const [pagination, setPagination] = useImmer({ page_size: 20 });
  const [permissionUpdateModel, setPemissionUpdateModel] = useImmer(initPemissionUpdateModel);
  const user_roles = useMemo(() => {
    let roleHierarchies = JSON.parse(localStorage.getItem("roleHierarchies"));
    let allowedRoleIdList = extractAllowedUserRoleList(roleHierarchies);
    return allowedRoleIdList;
  }, []);
  const data_loading = useMemo(() => permissionData.isLoading, [permissionData.isLoading]);
  const perm_table_rows = useMemo(() => Object.values(permissionData?.data), [permissionData.data]);
  const entity_list = useMemo(() => permissionData?.entity_list, [permissionData.entity_list]);

  useEffect(() => {
    getPermissions();
  }, []);

  const RoleModuleManagementCols = useMemo(() => {
    const ActionsColumns = (params) => {
      function openEditModal() {
        console.log("daslkfklsd", params);
        setPemissionUpdateModel((prev) => {
          prev.open = true;
          prev.data = params.row;
        });
      }

      return (
        <div className="flex items-center gap-2">
          <Tooltip placement="bottom" title="Edit" disableInteractive>
            <IconButton onClick={openEditModal}>
              {" "}
              <EditIcon className="cursor-pointer" />
            </IconButton>
          </Tooltip>
        </div>
      );
    };

    const cols = [
      {
        field: "actions",
        headerName: "",
        type: "actions",
        renderCell: ActionsColumns,
        hideable: false,
        disableExport: true,
      },
      {
        field: "role_name",
        headerName: "User Role",
        sortable: true,
        minWidth: 110,
        hideable: true,
        flex: 1,
      },
      {
        field: "Module Access",
        headerName: "module_access",
        sortable: true,
        minWidth: 110,
        hideable: true,
        flex: 9,
        renderCell: (params) => {
          const access_map = params.row?.role_entity_map || {};
          const _id = params.row.id;
          const allowed_modules = Object.entries(access_map).map(([module, isVisible], index) => {
            if (isVisible) {
              return (
                <Chip
                  className="users__table__station-chip"
                  key={"station" + _id + index}
                  label={module}
                  size="small"
                  variant="filled"
                />
              );
            }
          });

          return (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                gap: "0.2em",
                overflow: "auto",
                alignItems: "center",
              }}
            >
              {allowed_modules}
            </div>
          );
        },
      },
    ];
    return cols;
  }, [user_roles]);

  const getPermissions = async () => {
    const url = `${APP_BASE_URL}${USER_PERMISSION}`;

    // Start loading
    setPemissiondata((prev) => {
      prev.data = {};
      prev.isLoading = true;
      prev.entity_list = [];
    });

    try {
      const { data: permData = [] } = await axios.get(url).then((res) => res.data);

      const roleEntityMap = {};
      const entitySet = new Set();

      // Populate roleEntityMap and entitySet
      for (const packet of permData) {
        const { entity, role_name, user_role_id, read_all } = packet;
        if (["admin", "Admin", "ADMIN"].includes(role_name)) continue;

        entitySet.add(entity);
        const isVisible = read_all !== false;

        if (!roleEntityMap[role_name]) {
          roleEntityMap[role_name] = {
            id: role_name,
            role_name,
            user_role_id,
            role_entity_map: {},
          };
        }

        roleEntityMap[role_name].role_entity_map[entity] = isVisible;
      }

      // Add missing roles
      for (const role of user_roles) {
        if (["admin", "Admin", "ADMIN"].includes(role.value)) continue;
        if (!roleEntityMap[role.value]) {
          roleEntityMap[role.value] = {
            id: role.value,
            role_name: role.value,
            user_role_id: role.id,
            role_entity_map: {},
          };
        }
      }

      // Ensure all entities are present in each role
      const entities = Array.from(entitySet);
      for (const roleData of Object.values(roleEntityMap)) {
        for (const entity of entities) {
          if (!(entity in roleData.role_entity_map)) {
            roleData.role_entity_map[entity] = true;
          }
        }
      }

      // Finalize state
      setPemissiondata((prev) => ({
        data: roleEntityMap,
        entity_list: entities,
        isLoading: false,
      }));
    } catch (err) {
      toast.error(err.message || "Failed to fetch permissions.");
      setPemissiondata((prev) => ({
        isLoading: false,
      }));
    }
  };

  return (
    <div className="module-access-container page-container--card">
      <div className="header-label">Role Based Module Access</div>
      <DataTable
        tableInfo={{
          id: "role-module-access-table",
          label: "Role Based Module Access",
          requireAuthSign: false,
          timestamp: { startTs: null, endTs: null },
        }}
        loading={data_loading}
        rows={perm_table_rows}
        getRowHeight={(param, a) => {
          const fact = Object.keys(param?.model?.role_entity_map ?? {}).toString().length / 3;
          const default_height = 35;

          return default_height < fact ? fact : default_height;
        }}
        columns={RoleModuleManagementCols}
        showFilterButton={false}
        pageSize={pagination.page_size}
        pageSizeChange={(size) => {
          setPagination((prev) => {
            prev.page_size = size;
          });
        }}
      />
      {permissionUpdateModel.open && Boolean(permissionUpdateModel.data) && (
        <RoleUpdateModal
          open={permissionUpdateModel.open}
          data={permissionUpdateModel.data}
          refetchPermissions={()=>{
            getPermissions()
          }}
          handleCloseModal={() => {
            setPemissionUpdateModel(initPemissionUpdateModel);
          }}
        />
      )}
    </div>
  );
};

export default RoleModuleManagement;
